var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"publishBox"}},[_c('p',[_vm._v("Your "+_vm._s(_vm.type)+" is not published.")]),_vm._v(" "),(!_vm.item.primary_photo_id && !_vm.item.primary_photo_uuid)?_c('p',[_vm._v("Your "+_vm._s(_vm.type)+" needs a photo")]):_vm._e(),_vm._v(" "),_c('a',{staticClass:"secondaryButton",attrs:{"href":_vm.url}},[_vm._v(_vm._s(_vm.urlText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }